import moment from 'moment'

/** 解析 copycustom 响应（个股复制策略） */
export function parseCopyCustomApiResponse(res: any): any | null {
  return parseWatchwordApiResponse(res)
}

/** 解析 redeemWatchword 响应：兼容组合口令与个股复制策略 */
export function parseWatchwordApiResponse(res: any): any | null {
  if (!res) return null
  if (res?.data?.status === 2 || res?.status === 2) return null
  const inner = res.data
  const hasInnerPayload =
    inner &&
    (inner.factor != null ||
      inner.factors != null ||
      inner.stockRange != null ||
      inner.strategyName != null ||
      inner.factorBuy != null ||
      inner.factorSell != null ||
      inner.symbol != null ||
      inner.market != null)
  const payload = hasInnerPayload ? inner : res
  if (
    !(
      payload.factor ||
      payload.factors ||
      payload.stockRange ||
      payload.strategyName ||
      payload.factorBuy ||
      payload.factorSell ||
      payload.symbol ||
      payload.market
    )
  ) {
    return null
  }
  const ok =
    payload.status === 1 ||
    res.status === 1 ||
    res.code === 1 ||
    (hasInnerPayload && res.code === 1)
  return ok ? payload : null
}

/** 个股量化：口令 factorBuy/factorSell 项 → 页面选中结构 */
export function mapStockWatchwordFactor(apiItem: any, factorList: any[]) {
  if (!apiItem) return null
  const factorCode = String(apiItem.factorCode || '')
  if (!factorCode) return null
  const factor = factorList.find((f) => f.factorCode === factorCode)
  const apiOptions = Array.isArray(apiItem.options) ? apiItem.options : []
  const optionCode = apiOptions[0]?.optionCode != null ? String(apiOptions[0].optionCode) : ''
  let optionName = ''
  if (optionCode && factor?.options?.length) {
    const opt = factor.options.find((o: any) => o.optionCode === optionCode)
    optionName = opt?.optionName || apiOptions[0]?.optionName || ''
  } else if (apiOptions[0]?.optionName) {
    optionName = String(apiOptions[0].optionName)
  }
  return {
    factorCode,
    factorName: factor?.factorName || apiItem.factorName || factorCode,
    optionCode,
    optionName,
  }
}

export interface StockWatchwordHydrateTarget {
  selectedStock: { value: any }
  selectedBuy: { value: any }
  selectedSell: { value: any }
  selectedPeriod: { value: string }
  customDateRange: { value: any }
  buyList: any[]
  sellList: any[]
  periodList: any[]
}

/** 个股量化：将 watchword 接口数据回显到表单 */
export function hydrateStockFromWatchword(wd: any, target: StockWatchwordHydrateTarget) {
  if (!wd) return

  const symbol = wd.symbol || wd.baseInfo?.symbol || ''
  const market = (wd.market || wd.baseInfo?.market || '').toLowerCase()
  const name = wd.name || wd.stockName || wd.baseInfo?.name || ''
  if (symbol) {
    target.selectedStock.value = {
      securityNo: symbol,
      securityName: name,
      securityMarket: market,
    }
  }

  const buyFactors = Array.isArray(wd.factorBuy) ? wd.factorBuy : []
  if (buyFactors.length) {
    const mapped = mapStockWatchwordFactor(buyFactors[0], target.buyList)
    if (mapped) target.selectedBuy.value = mapped
  }

  const sellFactors = Array.isArray(wd.factorSell) ? wd.factorSell : []
  if (sellFactors.length) {
    const mapped = mapStockWatchwordFactor(sellFactors[0], target.sellList)
    if (mapped) target.selectedSell.value = mapped
  }

  if (wd.period === 'custom' && wd.periodStart != null && wd.periodEnd != null) {
    target.selectedPeriod.value = 'custom'
    target.customDateRange.value = [moment(wd.periodStart), moment(wd.periodEnd)]
    return
  }
  if (wd.period && target.periodList.some((p: any) => p.code === wd.period)) {
    target.selectedPeriod.value = wd.period
    target.customDateRange.value = null
  }
}
